import { render, staticRenderFns } from "./StatusTemplate.vue?vue&type=template&id=4fcd288b&scoped=true"
import script from "./StatusTemplate.vue?vue&type=script&lang=js"
export * from "./StatusTemplate.vue?vue&type=script&lang=js"
import style0 from "./StatusTemplate.vue?vue&type=style&index=0&id=4fcd288b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd288b",
  null
  
)

export default component.exports